import { createBrowserHistory } from 'history';

/**
 * Initial browser history
 */
const history = createBrowserHistory({ basename: '/' });

export default history;
